import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import {  QuoterequestComponent } from '../../common/quoterequest/quoterequest.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(public dialog: MatDialog) { }

  ngOnInit() {
    console.log("Entered Home Init");
    this.loadScript('../../assets/js/main.js');
  }



  public loadScript(url: string) {
    const body = <HTMLDivElement> document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = false;
    script.defer = true;
    body.appendChild(script);
  }

  openModal() {
    let dialogRef = this.dialog.open(QuoterequestComponent, {
        width: '400px',
        // data: { name: this.name, animal: this.animal }
    });

  }



}
